module.exports = __webpack_public_path__ + "static/media/list-bullets-brand-refresh.cb5d4fb9.svg";